import { debounce } from 'lodash'

const debouncedFormSubmit = debounce(form => {
  form.requestSubmit()
}, 650) // 650ms debounce time

export { debouncedFormSubmit }
